import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ReadonlyHttpApiCollectionRepository, Result } from '@softline/core';
import { SOFTLINE_API_GESCHAEFTSFALL_QUERY } from '../gesamtabfrage.api';
import { BusinessCase } from '../types/business-case.model';
import { BusinessCaseQuery } from '../types/business-case.query';

@Injectable()
export class BusinessCaseRepository extends ReadonlyHttpApiCollectionRepository<Result<BusinessCase[]>, BusinessCaseQuery> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_GESCHAEFTSFALL_QUERY);
  }

  override getLoadPayload(query: BusinessCaseQuery): BusinessCaseQuery {
    return query;
  }
}
